module.exports = __webpack_public_path__ + "static/univerzita-palackeho-7f50ebb71c1ce4a8f2eec7d6992ef033.png";